import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {sanitizeUrl} from "../../../../../helpers/misc";
import {closeDialog} from "../../../../../slices/dialog";
import React from "react";
import {Button} from "react-bootstrap";

export const CourseReminder = ({url}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const onLinkClick = () => {
        if (!url) return;
        window.open(sanitizeUrl(url), '_blank', 'noopener');

        dispatch(closeDialog());
    }

    return <>
        <p className="fs-3 mb-5">{t("student_follow_courseReminder_text")}</p>
        <Button onClick={onLinkClick} className="rounded-borders w-100">{t("student_follow_courseReminder_buttonText")}</Button>
    </>
}